import React, { useEffect, useState } from 'react'
import ToggleSwitch from '../components/toggles/ToggleSwitch'
import styled from 'styled-components'
import { addBarcodes } from '../utils/addBarcodes'
import BarcodeReader from 'react-barcode-reader'
import SolidButton from '../components/buttons/solid-button/SolidButton'
import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import Banner from '../components/hero/Banner'
import Header from '../components/header/Header'
import Container from '../components/container/Container'
import SuccessFlash from '../components/flash_message/SuccessFlash'
import ErrorFlash from '../components/flash_message/ErrorFlash'
import FormValidationError from '../components/flash_message/FormValidationError'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import useAuth from '../hooks/useAuth'
import ModalDrop from '../components/modals/ModalDrop'
import ScanError from '../components/scanning-error/ScanError'
import moment from 'moment'

const Title = styled.p`
  font-size: 15px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
`
const ScanCount = styled.div`
  margin-top: 18px;
  width: 100%;
`

const ScanOutout = styled.div`
  margin-top: 47px;
  width: 100%;
`
const Input = styled.input`
  width: ${props => props.width};
  border: 1px solid #d6d6d6;
  color: black;
  font-size: 16px;
  border-radius: 5px;
  height: 40px;
  padding: 0 5px;
`
const Label = styled.label`
  width: 100%;
  color: #8a8a8a;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
`
const FormInputControl = styled.div`
  width: 100%;
  margin: 10px 0;
`

function ReceivePackage () {
  const axiosprivate = useAxiosPrivate()
  const location = useLocation()
  const { auth, setLoading } = useAuth()
  const [count, setCount] = useState(0)
  const [scanCodes, setScanCodes] = useState([])
  const [barcode, setBarcode] = useState('Scan barcode...................')
  const [isBatch, setIsBatch] = useState(false)
  const [longitude, setLongitude] = useState('')
  const [latitude, setLatitude] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)
  const [isFail, setIsFail] = useState(false)
  const navigate = useNavigate()
  const [message, setMessage] = useState('Success')
  const [incompleteScan, setIncompleteScan] = useState(false)
  const [scanError, setScanError] = useState({
    show: false,
    errorMessage: '',
    barcode: ''
  })

  useEffect(() => {
    count === 1 && !isBatch && handleSubmit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBatch, count])

  //clear out scan box
  useEffect(() => {
    setTimeout(() => {
      setBarcode('Scan barcode...................')
    }, 1000)
    return () => {
      clearTimeout()
    }
  }, [barcode])

  useEffect(() => {
    navigator.permissions.query({ name: 'geolocation' }).then(resp => {
      if (resp.state === 'granted') {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(success, error)
        }
      } else if (resp.state === 'denied') {
        navigate('/', { state: { from: location }, replace: true })
      }
    })

    function success (position) {
      setLatitude(`${position.coords.latitude}`)
      setLongitude(`${position.coords.longitude}`)
    }

    function error (err) {
      console.error(err)
      navigate('/', { state: { from: location }, replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  //toggle state
  const logState = state => {
    setScanCodes([])
    setCount(0)
    setIsBatch(state)
  }

  //get barcodes
  const handleScan = async data => {
    setIncompleteScan(false)
    setBarcode(data)
    setIsFail(false)
    setIsSuccess(false)

    if (isBatch) {
      //check if label is SSCC
      if (data.substring(0, 2) === '00' && data.substring(3, 6) === '615') {
        if (data.length < 20) {
          setIncompleteScan(true)
          return
        } else {
          let filteredArray = addBarcodes(data, scanCodes)
          setScanCodes([...filteredArray])
          setCount(filteredArray.length)
          return
        }
      } else {
        if (data.length < 40) {
          setIncompleteScan(true)
          return
        } else {
          let filteredArray = addBarcodes(data, scanCodes)
          setScanCodes([...filteredArray])
          setCount(filteredArray.length)
          return
        }
      }
    } else {
      //check if label is SSCC
      if (data.substring(0, 2) === '00' && data.substring(3, 6) === '615') {
        if (data.length < 20) {
          setIncompleteScan(true)
          return
        } else {
          let filteredArray = addBarcodes(data, scanCodes)
          setScanCodes([...filteredArray])
          setCount(filteredArray.length)
          return
        }
      } else {
        if (data.length < 40) {
          setIncompleteScan(true)
          return
        } else {
          let filteredArray = addBarcodes(data, scanCodes)
          setScanCodes([...filteredArray])
          setCount(filteredArray.length)
          return
        }
      }
    }
  }

  //handle error
  async function handleError (err) {
    console.error(err)
  }

  //Endpoint to receive
  const receiving = async data =>
    await axiosprivate.post('/gs1/standard/label/receive', data)

  //query to send to backend
  const { mutate, isLoading } = useMutation(variables => receiving(variables), {
    onSuccess (data, variables, context) {
      setScanCodes([])
      setCount(0)
      setIsSuccess(true)
      setMessage('Success')
    },
    onError (error) {
      setScanCodes([])
      setCount(0)
      setIsFail(true)
      if (error.code === 'ERR_NETWORK') setMessage('Please Check Your Network')
      else if (
        error?.response?.status === 401 ||
        error?.response?.status === 403
      )
        navigate('/', { state: { from: location }, replace: true })
      else {
        const message = error.response.data.message
        if (message.includes('SQL')) {
          setMessage('Server Error')
        } else {
          setMessage(error.response.data.message?.replace('Unknow', 'Unknown'))
        }
      }
    }
  })

  const resetScanError = () => {
    setScanError({ show: false, errorMessage: '', barcode: '' })
  }

  //handle submit
  const handleSubmit = () => {
    const offset = moment().format('Z')
    const payload = {
      clientId: auth.user.clientId || 4,
      eventObjectParameter: {
		readPoint: auth?.user?.location,
		// readPoint: "6156000010014",
        eventTime: new Date().toISOString().replace('Z', ''),
        recordTime: new Date().toISOString().replace('Z', ''),
        latitude: latitude,
        longitude: longitude,
        bizStep: 'urn:epcglobal:cbv:bizstep:receiving',
        disposition: 'urn:epcglobal:cbv:disp:active',
        timeZone: offset
      },
      receivingData: {
        elementstrings: scanCodes
      }
    }
    mutate(payload)
  }

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading, setLoading])

  return (
    <Container>
      {scanError.show && (
        <ModalDrop>
          <ScanError
            onClose={resetScanError}
            barCode={scanError.barcode}
            errorMessage={scanError.errorMessage}
          />
        </ModalDrop>
      )}
      <BarcodeReader
        onError={handleError}
        onScan={handleScan}
        timeBeforeScanTest={1000}
      />

      <Header>{'Receive Package'} </Header>
      <div style={{ position: 'relative', margin: '20px 0' }}>
        <ToggleSwitch toggled={false} onClick={logState} />
      </div>
      <Banner />

      <div>
        <small
          style={{
            fontSize: '12px',
            marginTop: '8px',
            marginBottom: '8px',
            display: 'block'
          }}
        >
          Please click on the "scan barcode" field first, then start scanning
          labels for packages to be received.{' '}
          {isBatch ? " Then click the 'Submit' button when you are done" : ''}
        </small>
      </div>
      <Title>Scanning Details</Title>
      <ScanCount>
        <FormInputControl>
          <Label>Quantity</Label>
        </FormInputControl>
        <FormInputControl>
          <Input width={'100%'} value={count} disabled type='number' />
        </FormInputControl>
      </ScanCount>
      <ScanOutout>
        <FormInputControl>
          <Label>Barcode</Label>
        </FormInputControl>
        <FormInputControl>
          <Input
            value={barcode}
            width={'100%'}
            style={{ fontSize: '12px' }}
            disabled
          />
          {incompleteScan && (
            <FormValidationError text={'Incomplete scan.. please rescan!!!!'} />
          )}
        </FormInputControl>
      </ScanOutout>

      {isBatch && count > 0 && !isLoading && (
        <FormInputControl style={{ marginTop: '40px' }}>
          <SolidButton width={'100%'} onclick={handleSubmit} />
        </FormInputControl>
      )}

      <FormInputControl style={{ marginTop: '20px' }}>
        <SuccessFlash display={isSuccess}>{message}</SuccessFlash>
      </FormInputControl>

      <FormInputControl style={{ marginTop: '20px' }}>
        <ErrorFlash display={isFail}>{message}</ErrorFlash>
      </FormInputControl>
    </Container>
  )
}

export default ReceivePackage
